import { Box, Container, SxProps, Theme } from "@mui/material";

interface SectionContainerProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  contentSx?: SxProps<Theme>;
}

export const SectionContainer = ({ children, sx, contentSx }: SectionContainerProps) => {
  const baseSx: SxProps<Theme> = {
    padding: "80px 0",
    background: "#f8f9fa",
    width: "100%",
    boxSizing: "border-box",
    ...sx,
  };

  return (
    <Box sx={baseSx}>
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          px: { md: 3, xs: 2 },
          boxSizing: "border-box",
          ...contentSx,
        }}
      >
        {children}
      </Container>
    </Box>
  );
};
